import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { LinkItem as Link } from '@atlaskit/menu';
import { baseSideNavItemStyle, overrideStyleFunction } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
var LinkItem = /*#__PURE__*/forwardRef( // Type needed on props to extract types with extract react types.
function (_ref, ref) {
  var cssFn = _ref.cssFn,
      rest = _objectWithoutProperties(_ref, ["cssFn"]);

  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  if (!shouldRender) {
    return null;
  }

  var cssOverride = overrideStyleFunction(baseSideNavItemStyle, cssFn);
  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref,
    cssFn: cssOverride
  }, rest));
});
export default LinkItem;